module.exports = __webpack_public_path__ + "static/media/icon-elite-partner.289980ea.svg";